import { render, staticRenderFns } from "./AddCampaignButton.vue?vue&type=template&id=35eec12f&scoped=true&"
import script from "./AddCampaignButton.vue?vue&type=script&lang=js&"
export * from "./AddCampaignButton.vue?vue&type=script&lang=js&"
import style0 from "./AddCampaignButton.vue?vue&type=style&index=0&id=35eec12f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35eec12f",
  null
  
)

/* custom blocks */
import block0 from "./AddCampaignButton.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports